// extracted by mini-css-extract-plugin
module.exports = {"collapse":"styles_collapse__34yfj"};